<script>
  import { inject, ref } from '@vue/composition-api'

  import { useMapActions, useMapGetters } from '@/xstore'

  export default {
    name: 'StaticMainPageSubmitButtonComponent',
    setup() {
      const isProcessing = ref(false)
      return {
        isProcessing,
        ...useMapGetters(inject('formSubmitStoreModulePath'), [
          'getCurrentPage',
          'getFormSourceJSON',
        ]),
        ...useMapActions(inject('formSubmitStoreModulePath'), [
          'goToNextPage',
          'goToFinishPage',
        ]),
      }
    },
    methods: {
      executeButtonAction() {
        if (this.isProcessing) return
        this.isProcessing = true
        this.$emit('validate', this.pageValidationPassed)
      },
      async pageValidationPassed() {
        const action =
          this.getCurrentPage.submit_button.properties.on_click_action
        try {
          if (action === 'go_to_next_page') {
            await this.goToNextPage()
          } else if (action === 'submit_form') {
            await this.goToFinishPage()
          }
        } finally {
          this.isProcessing = false
        }
      },
    },
  }
</script>

<template>
  <div class="static-main-page__footer-wrapper">
    <div class="static-main-page-footer">
      <div class="static-page-action-button-wrapper">
        <div
          class="static-page-action-button"
          :class="{ 'static-page-action-button--disabled': isProcessing }"
          :aria-disabled="isProcessing"
          :style="isProcessing ? 'pointer-events: none; opacity: 0.6;' : ''"
          @click="executeButtonAction"
        >
          <span
            class="static-page-action-button__text static-page-action-button__text--readonly"
          >
            {{ getCurrentPage.submit_button.properties.button_text || 'Next' }}
          </span>
        </div>
      </div>
      <div class="static-main-page-footer__disclaimer">
        Never submit passwords through Forms
      </div>
    </div>
    <div class="static-main-page-footer-transition-helper"></div>
  </div>
</template>

<style scoped>
  .static-page-action-button--disabled {
    pointer-events: none;
    opacity: 0.6;
  }
</style>
